export const getGroupPermissionsDetails = (state) =>
  state.groups.groupPermissions;
export const getGroupPermissionExpanded = (state, nodeId) =>
  !!state.groups.groupPermissions.expandedIds[nodeId];
export const getGroupPermissionLoading = (state, nodeId) =>
  !!state.groups.groupPermissions.loadingIds[nodeId];
export const getGroupPermissionInScope = (state, nodeId) =>
  !!state.groups.groupPermissions.customisedValues[nodeId].inScope;
export const getGroupPermissionSaving = (state) =>
  !!state.groups.groupPermissions.saving;

export const getGroupPermissionHasPartialChildScope = (state, nodeId) =>
  !!state.groups.groupPermissions.customisedValues[nodeId].hasPartialChildScope;
